import React from 'react';
import PropTypes from 'prop-types';

import {
  FilterItemContainer,
  Label,
  Dropdown,
} from './styles';

/**
 *  example of default filters to use in your component
 *  not sending any of these, the server will use default values
 *  const [defaultFilters, setDefaultFilters] = useState({
 *  guest: true, // true or false
 *  status: 'active', // active or pending_approval
 *  lastLoginMonths: 12, // any number
 *  Also dont forget to add propertyName into your custom onChange function
 */

const DefaultFilterUsers = (props) => {
  const {
    defaultFilters,
    setDefaultFilters,
    onChange,
  } = props;

  const onChangeDefault = (e, { value }, propertyName) => {
    setDefaultFilters({ ...defaultFilters, [propertyName]: value });
  };

  // if you want to override the onChange, just pass the component the onChange
  const functionOnChangeToUse = onChange || onChangeDefault;

  return (
    <>
      <FilterItemContainer>
        <Label>Users by: </Label>
        <Dropdown
          value={defaultFilters.guest}
          selection
          options={[
            {
              key: true,
              text: 'Tester & Guest',
              value: true,
            },
            {
              key: false,
              text: 'Tester',
              value: false,
            },
          ]}
          onChange={(e, { value }) => functionOnChangeToUse(e, { value }, 'guest')}
        />
      </FilterItemContainer>
      <FilterItemContainer>
        <Label>User status: </Label>
        <Dropdown
          value={defaultFilters.status}
          selection
          options={[
            {
              key: 'active',
              text: 'Active',
              value: 'active',
            },
            {
              key: 'pending_approval',
              text: 'Pending Approval',
              value: 'pending_approval',
            },
          ]}
          onChange={(e, { value }) => functionOnChangeToUse(e, { value }, 'status')}
        />
      </FilterItemContainer>
      <FilterItemContainer>
        <Label>Last login: </Label>
        <Dropdown
          selection
          value={defaultFilters.lastLoginMonths}
          options={[
            {
              key: 24,
              text: '2 years ago',
              value: 24,
            },
            {
              key: 12,
              text: '1 year ago',
              value: 12,
            },
          ]}
          onChange={(e, { value }) => functionOnChangeToUse(e, { value }, 'lastLoginMonths')}
        />
      </FilterItemContainer>
    </>
  );
};

DefaultFilterUsers.propTypes = {
  defaultFilters: PropTypes.shape({
    guest: PropTypes.bool,
    status: PropTypes.oneOf(['active', 'pending_approval']),
    lastLoginMonths: PropTypes.number,
  }).isRequired,
  setDefaultFilters: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DefaultFilterUsers;
